import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import { Button } from '@mui/material';
import { ColumnsPanelTrigger } from '@mui/x-data-grid-premium';
import { FC, memo } from 'react';

const MyGridToolbarColumnsButton: FC = memo(() => {
  return (
    <ColumnsPanelTrigger
      render={(props) => (
        <Button
          {...props}
          size="small"
          startIcon={<ViewColumnIcon />}
          sx={{ minWidth: 'auto' }}
        >
          列一覧
        </Button>
      )}
    />
  );
});

MyGridToolbarColumnsButton.displayName = 'GridToolbarColumnsButton';

export default MyGridToolbarColumnsButton;
